// extracted by mini-css-extract-plugin
export const header = "style-module--header--2zV4r";
export const header__backgroundWrapper = "style-module--header__backgroundWrapper--1HDka";
export const header__backgroundImage = "style-module--header__backgroundImage--2vuSs";
export const header__content = "style-module--header__content--i9fHM";
export const header__title = "style-module--header__title--2yr5X";
export const header__title_1 = "style-module--header__title_1--2jxbb";
export const header__title_2 = "style-module--header__title_2--1Gy5Q";